// removed by extract-text-webpack-plugin
module.exports = {"class-calendar":"class-calendar","rbc-month-header":"rbc-month-header","rbc-month-row":"rbc-month-row","rbc-overlay":"rbc-overlay","rbc-month-view":"rbc-month-view","rbc-off-range-bg":"rbc-off-range-bg","rbc-event":"rbc-event","fetching":"fetching"};


//////////////////
// WEBPACK FOOTER
// ./src/template/ClassCalendar/ClassCalendar.scss
// module id = KIGD
// module chunks = 0